import QuestMinigame from "../QuestMinigame";

export default class MinigameSnakeAttack extends QuestMinigame {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        super(id, owner);

        this._enemy = null;
        this._spawnTime = 0;
        this._spawnDelay = 0;

        this._npc = null;
        this._activeEnemies = [];

        this.coins = 1;
    }

    /**
     * @param {object} metadata
     */
    init(metadata) {
        super.init(metadata);

        this._enemy = metadata.enemy;
        this._spawnDelay = Math.max(metadata.spawnDelay);
        this._spawnLimit = Math.max(metadata.spawnLimit);
        this.coins = metadata.coins;

        this.bgmName = "music_minigame_fight_challenge_loop";
    }

    /**
     * @param {GameScene} game
     */
    spawnEnemy(game) {
        const position = game.world.findSafePosition(this._npc.position, 240, 200, 40, [], 20);
        const enemy = game.createEnemy(this._enemy, position, false, false);
        enemy.target = game.player;
        enemy.alwaysAggro = true;
        enemy.signals.dead.add(this.onEnemyDead, this);
        this._activeEnemies.push(enemy);
    }

    /**
     * @param {GameScene} game
     */
    removeAllEnemies(game) {
        for (let i = 0, count = this._activeEnemies.length; i < count; ++i) {
            const enemy = this._activeEnemies[i];
            game.removeEnemy(enemy);
        }
    }

    /**
     * @param {Enemy} enemy
     */
    onEnemyDead(enemy) {
        const i = this._activeEnemies.indexOf(enemy);
        if (i >= 0) {
            ++this.score;
            this._activeEnemies.splice(i, 1);
        }
    }

    /**
     * @param {GameScene} game
     */
    onMinigameStart(game) {
        super.onMinigameStart(game);

        this._npc = game.findNPC(this.owner);
    }

    /**
     * @param {GameScene} game
     */
    onMinigameUpdate(game) {
        super.onMinigameUpdate();

        if (this.isRunning) {
            const enemyCount = this._activeEnemies.length;
            if (enemyCount < this._spawnLimit) {
                if (this._spawnTime > this._spawnDelay) {
                    this._spawnTime = 0;
                    this.spawnEnemy(game);
                }
                this._spawnTime += window.dt;
            }
        }
    }

    /**
     * @param {GameScene} game
     */
    onMinigameEnd(game) {
        super.onMinigameEnd(game);

        this.removeAllEnemies(game);

        this.bestScore = this.score;
        //console.log("score:", this.score);
    }
}